export class AlertDetail{
    Status:string=''
    Message:string=''
}